<p-dialog header="Confirm Combine" [(visible)]="visible" [style]="{ width: '500px' }">
  <p>
    One or more of the jobs you are combining currently has grabbing disabled. The combined job will
    not have grabbing disabled.
  </p>

  <p-footer>
    <button
      type="button"
      pButton
      label="Cancel"
      (click)="visibleChange.emit(false)"
      class="ui-button-danger"
    ></button>
    <button
      type="button"
      pButton
      label="Combine"
      (click)="confirm()"
      class="ui-button-primary"
    ></button>
  </p-footer>
</p-dialog>
